import { render, staticRenderFns } from "./BaseThumbnailUpload.vue?vue&type=template&id=2100616d&scoped=true&"
import script from "./BaseThumbnailUpload.vue?vue&type=script&lang=js&"
export * from "./BaseThumbnailUpload.vue?vue&type=script&lang=js&"
import style0 from "./BaseThumbnailUpload.vue?vue&type=style&index=0&id=2100616d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2100616d",
  null
  
)

export default component.exports